import ApiService from './ApiService';

export default class UploadsService {
  static async fetchAll() {
    return await ApiService.get('/uploads');
  }

  static async create(data) {
    return await ApiService.post('/uploads', data);
  }

  static async delete(id) {
    return await ApiService.delete(`/uploads/${id}`);
  }
}
